import React from 'react';
import * as Tools from "../../../helpers/Tools";
import { Modal } from '../../ecosystem';

const VideoVisitTips = (props) => {

    const isMobile = Tools.isMobile();

    return (
        <Modal
            className="appt-videovisit-modal"
            isOpen={props.showVideoVisitTipsModal}
            icon="video-visit"
            modalHeader="Helpful Video Tips"
            modalBody={<div className="row">
                <div className="col-12 text-left">
                    <ul className="angle-bullets">
                        <li>Ensure a quiet, well-lit and private location</li>
                        <li>Ensure a reliable wi-fi or cellular data connection in your location (cellular data usage and limits are per the respective user's data plan)</li>
                        <li>Try restarting your device or computer if you're experiencing issues</li>
                        <li>Ensure your device or computer is fully charged or plugged in</li>
                        <li>If possible, you may want to try a different device (smart phone, tablet, computer, etc.)</li>
                        <li>If your video disconnects you can reconnect through the same button</li>
                        {!isMobile &&
                            <li>Browser: Try <span><a href="https://www.google.com/chrome/" target="_blank">Chrome</a></span> for the best video experience</li>
                        }
                    </ul>
                </div>
            </div>}
            toggle={props.toggleVideoVisitTipsModal}
            onCloseClick={props.toggleVideoVisitTipsModal}
        />);
};

export default VideoVisitTips;



